
export class User {
   loginFlag!:string;
   userId!: number;
   loginName!: string;
   firstName!: string;
   lastName!: string;
   roleRights!: string;
   moduleMap : any;
   lastLogindt!: string;
   organizationId!: number;
   customerId!: string;
   orgCode!: string;
   loginKey!: string;
   noOfSecQuesAns!: string;
   noOfSecQuesConf!: string;
   orgName!: string;
   rightsXml!: string;
   companyName!: string;
   email!: string;
   isActive!: number;
   userIsExternal!: number;
   timeszone!: string;
   phno!: string;
   clientUserId!: string;
   userisActive!: string;
   language!: string;
   fieldMap : any;
   policyMap :any;
   userTimezoneOffset!: string;
   userTimezoneIntOffset!: string;
   userShortTzName!: string;
   answeredSecQuesList :any;
   userFullName!: string;
   jobType!: string;
   userType!:string;
   pwdPolicyMap:any;
   secQuesString!:string;
   secQuesList!:any;
   errorMessage!:string;
   userLoginFlag!:string;
   meetingId:any;
   jwtToken!:string;
   encLoginName!:string;
}

export interface questionDetails{
   quesCode:string;
   quesDesc:string;
}
export interface ReportUser{
   name:string;
   userId:number;
   user_fullname:string,
   user_firstname:string,
   user_lastname:string,
   pk_userid:number
}
